// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Проєктування документів» (Document design, ключ `docdes`, група `documents`). */
export const documentDesignManifest: IModuleManifest = {
  key: 'docdes',
  group: 'documents',
  slug: 'document-design',
  prefix: 'DDS',
  name: { en: 'Document design', uk: 'Проєктування документів' },
  entities: [
    { key: 'docdes', slug: 'docdes', name: { en: 'Document design', uk: 'Проєктування документів' }, main: true },
  ],
  loadState: () => import('./state/documentDesignSlice').then((m) => m.documentDesignSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
